import { EventManagerAsyncProvider } from '@core/events/event-manager'
import { UserStore } from '../storage/user-storage-manager'
import { SettingsStore } from '../storage/settings-storage-manager'
import { TrackedEvent } from '@core/events/tracked-event'
import { Globals } from '../globals.ts'
import { Env } from '../env.ts'
import { UserProfile } from '../modules/user-profile.ts'

/** @internal */
export class EventManagerAsyncSettingsProvider implements EventManagerAsyncProvider {
    private _userProfileMod?: UserProfile

    public constructor(
        private readonly settingsStore: SettingsStore,
        private readonly userStore: UserStore,
    ) {}

    public get _isBaseEnvSupported(): boolean {
        return Env._getIsEnvBaseSupported()[0]
    }

    public setUserProfileModule(mod: UserProfile) {
        this._userProfileMod = mod
    }

    public async _canSend() {
        return this.userStore._getIsTrackingHalted().then((isHalted) => !isHalted)
    }

    public async _getAnonymousId() {
        return this.userStore._getAnonymousId()
    }

    public async _getIsSubscribed() {
        return this.userStore._getIsSubscribed()
    }

    public async _getToken() {
        if (!this._isBaseEnvSupported || !this._userProfileMod) {
            // Bypass IDB
            return null
        }

        return this._userProfileMod.getToken()
    }

    public async _getDomainId() {
        let domainId = Globals._injectedDomainConfig?.id ?? null

        if (!domainId) {
            const configValue = await this.settingsStore._getDomainConfig()
            domainId = configValue?.value?.id ?? null
        }

        return domainId
    }

    public async _getCachedEvents() {
        return this.settingsStore._getCachedEvents()
    }

    public async _setCachedEvents(events: TrackedEvent[]) {
        return this.settingsStore._setCachedEvents(events)
    }

    public async _getWriteAheadEvents() {
        return this.settingsStore._getWriteAheadEvents()
    }

    public async _addWriteAheadEvent(event: TrackedEvent) {
        return this.settingsStore._addWriteAheadEvent(event)
    }

    public async _removeWriteAheadEvent(eventId: string) {
        return this.settingsStore._removeWriteAheadEvent(eventId)
    }
}
